import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { UpdateStyleFunction } from "../Stylebuilder";
import ButtonField from "./ButtonsField";
import MapButtonField from "./MapButtonField";
import TextInputField from "./TextInputField";
import MeasurementField from "./MeasurementField";
import SelectField from "./SelectField";
import { ReactNode } from "react";
import ColorInputField from "./ColorInputField";
import LinkField from "./LinkField";
import SliderField from "./SliderFeild";
import AnchorField from "./AnchorField";
import { SiteData } from "../Data/SiteData";
import ImageField from "./ImageField";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import AlignmentField from "./AlignmentField";
import FontField from "./FontField";
import BorderField from "./BorderField";
import CustomClipShape from "./CustomClipShape";
import LockField from "./LockField";
import LinkToEditInVagaro from "./LinkToEditInVagaro";
import MultiLocationField from "./MultiLocationField";
import CodeField from "./CodeField";
import ShadowField from "./ShadowField";
import FlexDirField from "./FlexDirField";
import StarColor from "./StarColorField";
import EmojiInputField from "./EmojiInputField";
import ServiceFilterField from "./ServiceFilterField";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import ConditionalField from "./ConditionalField";
import FormListField from "./FormListField";
import RadioField from "./RadioField";
import SingleCheckField from "./SingleCheckFIeld";
import MultiPageSelect from "./MultiPageSelect";
import SimplePageSelectField from "./SimplePageSelectField";
import TabsInputField from "./TabsInputField";
import BackgroundField from "./BackgroundField";
import OverlayField from "./OverlayField";
import ProductFilterField from "./ProductFilterField";
import BlogFilterField from "./BlogFilterField";
import ManageBlogSettingsField from "./ManageBlogSettingsField";
import MembershipFilterField from "./MembershipFilterField";



export type AttributeFieldProps = {
    label:ReactNode,
    definition:AttributeDefinition,
    screenSize:ScreenSize,
    layoutObject:AttributeCollection,
    updateFunc:UpdateStyleFunction,
    saveFunc:Function,
    siteData:SiteData,
}
export default function RenderAttributeInput(props:AttributeFieldProps){


    switch(props.definition.inputType){

        case AttributeInputType.ButtonField:
            return<ButtonField {...props} />
        case AttributeInputType.EmojiField:
            return <EmojiInputField {...props} />
        case AttributeInputType.InputFiled:
          return <TextInputField {...props}/>
        case AttributeInputType.URLField:
            return <TextInputField {...props} validateURL={true}/>
        case AttributeInputType.CSSField:
            return <CodeField {...props} helpType="css"/>
        case AttributeInputType.HTMLField:
             return <CodeField {...props} helpType="html"/>
        case AttributeInputType.MeasurementField:
            return <MeasurementField {...props} isFourWay={false}/>
        case AttributeInputType.FourwayMeasurmentField:
            return <MeasurementField {...props} isFourWay={true}/>
        case AttributeInputType.SelectField:
            return <SelectField {...props}/>
        case AttributeInputType.ColorField:
            return <ColorInputField {...props}/>
        case AttributeInputType.ColorFieldWithDebounce:
            return <ColorInputField {...props} debounceDuration={250}/>
        case AttributeInputType.RangeSliderField:
            return <SliderField {...props}/>
        case AttributeInputType.AnchorField:
            return <AnchorField {...props}/>
        case AttributeInputType.ImageField:
            return <ImageField {...props}/>
        case AttributeInputType.BackgroundImage:
            return <BackgroundField {...props}/>
        case AttributeInputType.AlignmentField:
            return <AlignmentField {...props}/>
        case AttributeInputType.LinkField:
            return <LinkField {...props}/>
        case AttributeInputType.ClipPathField:
            return <CustomClipShape {...props}/>
        case AttributeInputType.FontField:
            return <FontField   {...props}/>
        case AttributeInputType.BorderField:
            return <BorderField {...props}/>
        case AttributeInputType.LockField:
            return <LockField   {...props}/>
        case AttributeInputType.ExternalLink:
            return <LinkToEditInVagaro {...props}/>
        case AttributeInputType.MultiLocation:
            return <MultiLocationField {...props}/>
        case AttributeInputType.ShadowField:
            return <ShadowField  {...props}/>
        case AttributeInputType.FlexDirField:
            return <FlexDirField {...props} />
        case AttributeInputType.StarColorField:
            return <StarColor {...props} />
        case AttributeInputType.DuplicatedPageSelectField:
            return <SimplePageSelectField {...props} />
        case AttributeInputType.MapButtonField:
                return<MapButtonField {...props} />
        case AttributeInputType.ServiceCategorySelector:
            //refresh the filter list when the location has changed
            let loc = getNodeComponentAttributeValue(props.layoutObject,componentAttributeTypes.multiLocation,props.siteData.userContext.businessId);
            return <ServiceFilterField key={loc} {...props}/>
        case AttributeInputType.Conditional:
            return <ConditionalField {...props}/>
        case AttributeInputType.FormSelectField:
            let locs = getNodeComponentAttributeValue(props.layoutObject,componentAttributeTypes.multiLocation,props.siteData.userContext.businessId);
            return <FormListField key={locs} {...props} />
       case AttributeInputType.ClassCategorySelector:
                //refresh the filter list when the location has changed
            let locB = getNodeComponentAttributeValue(props.layoutObject,componentAttributeTypes.multiLocation,props.siteData.userContext.businessId);
            return <ServiceFilterField key={locB} {...props} filterClasses={true}/>
        case AttributeInputType.MembershipSelector:
            return <MembershipFilterField {...props} />
        case AttributeInputType.PackageSelector:
            return <MembershipFilterField {...props} />
        case AttributeInputType.RadioField:
            return <RadioField {...props}/>
        case AttributeInputType.SingleCheckField:
            return <SingleCheckField {...props}/>
        case AttributeInputType.MultiPageSelect:
            return <MultiPageSelect {...props}/>
        case AttributeInputType.TabsField:
            return <TabsInputField {...props}/>
        case AttributeInputType.WhiteLabel:
            
                return null;
        case AttributeInputType.Ignore: 
            return null;
        case AttributeInputType.OverlayField:
            return <OverlayField {...props}/>
        case AttributeInputType.ProductFilters:
            return <ProductFilterField {...props}/>
        case AttributeInputType.BlogFilter:
            return <BlogFilterField {...props}/>
        case AttributeInputType.BlogSettingsButton:
            return <ManageBlogSettingsField {...props}/>

        default:
            return <div>Invalid Type: {props.definition.inputType}</div>;

    }

    
}